import Text from '../../../../../../shared/components/features/text/Text';
import classes from './InfoPartText.module.css';
import { useSelector } from 'react-redux';

const InfoPartText = ({ infoText, titleSection }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <div className={`${classes.InfoPartText} ${classes.InfoSection}`}>
            <Text className={classes.TitleSection}>{texts[titleSection]}</Text>

            <div className={classes.TextWraaper}>
                {infoText?.map(infoText =>
                    <div className={classes.InfoText}>
                        <img className={classes.Img} src={infoText.img} alt='' />
                        <Text className={classes.Title}>{texts[infoText.title]}</Text>
                        <Text className={classes.Text}>{texts[infoText.text]}</Text>
                    </div>
                )}
            </div>
        </div>
    )
}
export default InfoPartText;